/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TipoContratoEnum = 1 | 2 | 3 | 4 | 5 | 6;

export const TipoContratoEnum = {

    NUMBER_1: 1 as TipoContratoEnum,

    NUMBER_2: 2 as TipoContratoEnum,

    NUMBER_3: 3 as TipoContratoEnum,

    NUMBER_4: 4 as TipoContratoEnum,

    NUMBER_5: 5 as TipoContratoEnum,

    NUMBER_6: 6 as TipoContratoEnum
};

